export default __webpack_public_path__ + "static/media/drum.5f992657.png";